import { render, staticRenderFns } from "./DadosCasamentoLegado.vue?vue&type=template&id=0965167b&"
import script from "./DadosCasamentoLegado.vue?vue&type=script&lang=js&"
export * from "./DadosCasamentoLegado.vue?vue&type=script&lang=js&"
import style0 from "./DadosCasamentoLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports